import actions from './actions';

const initState = {
  isLoading: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.SEARCH_MEMBER_TICKET_DETAILS_AND_ACTIVITIES:
    case actions.SEARCH_MEMBER_TICKET_ISSUED_AND_ACTIVITIES: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case actions.SEARCH_MEMBER_TICKET_DETAILS_AND_ACTIVITIES_ENDED:
    case actions.SEARCH_MEMBER_TICKET_ISSUED_AND_ACTIVITIES_ENDED: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
